import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import get from 'lodash.get';
import { I18n, Translate } from 'react-redux-i18n';
import { cloneDeep } from 'lodash';
import dayjs from 'dayjs';
import NavigationStateManager from '../../../helpers/NavigationStateManager';

import * as templateBuilderActions from '../../../modules/template-builder-ex';
import * as programActions from '../store/vipProgramActions';
import { formBuilderActions } from '../../../components/formbuilder/store';

import update from '../../../helpers/update';
import { Record } from '../../../modules/bin/utility';
import { withRouterV6 } from '../../../helpers/withRouterV6';

import VipProgramTemplate from '../create/templateEx';
import RecordResultMessage from '../../../components/common/recordResult';
import BasePage from '../../../components/common/basePageView';
import clear from '../../../components/clear';
import Spinner from '../../../components/common/spinner';

import {
  customFieldCategory,
  generalFormBuilderPath
} from '../../../constants/formBuilder';
import { TemplateOptions } from '../../../components/template/templateOptions';
import { paths } from '../create/constants/template';
import config from '../../../constants';
import { formatDateWithPattern } from '../../../utils/time/formatDateWithPattern';
import { withPageTitle } from '../../../hocs';

class EditVipProgram extends Component {
  constructor(props) {
    super(props);
    const eventId = get(props, 'match.params.eventId');

    props.programActions.getEventAmbassadorProgramByEventRecord(eventId);
  }

  onSave = (data) => {
    this.props.programActions.updateRecord(data);
  };

  onCancel = (data) => {
    this.props.templateBuilderActions.clearItems(data);
    this.goToVipProgramsView();
  };

  isAllRecordsReady = () => {
    return Record.isRecordReady(this.props.eventAmbassadorProgramRecord);
  };

  initTemplate = () => {
    let eventAmbassadorProgram = cloneDeep(
      get(this.props, 'eventAmbassadorProgramRecord.data.data')
    );

    const applicationsPartOneFormBuilder = get(
      eventAmbassadorProgram,
      `${generalFormBuilderPath}.${customFieldCategory.ENTRY}`
    );
    const applicationsPartTwoFormBuilder = get(
      eventAmbassadorProgram,
      `${generalFormBuilderPath}.${customFieldCategory.CONFIRMATION}`
    );
    const templateOptions = new TemplateOptions();

    templateOptions.hide(paths.EVENT);

    //date
    const applicationsOpenDate = get(
      eventAmbassadorProgram,
      paths.DATE_APPLICATIONS_OPEN
    );
    if (applicationsOpenDate && dayjs(applicationsOpenDate).isValid()) {
      eventAmbassadorProgram = update.set(
        eventAmbassadorProgram,
        paths.DATE_APPLICATIONS_OPEN,
        formatDateWithPattern(applicationsOpenDate, config.DEFAULT_DATE_FORMAT)
      );
    }

    const applicationsCloseDate = get(
      eventAmbassadorProgram,
      paths.DATE_APPLICATIONS_CLOSE
    );
    if (applicationsOpenDate && dayjs(applicationsOpenDate).isValid()) {
      eventAmbassadorProgram = update.set(
        eventAmbassadorProgram,
        paths.DATE_APPLICATIONS_CLOSE,
        formatDateWithPattern(applicationsCloseDate, config.DEFAULT_DATE_FORMAT)
      );
    }

    const claimsCloseDate = get(
      eventAmbassadorProgram,
      paths.DATE_CLAIMS_CLOSE
    );
    if (claimsCloseDate && dayjs(claimsCloseDate).isValid()) {
      eventAmbassadorProgram = update.set(
        eventAmbassadorProgram,
        paths.DATE_CLAIMS_CLOSE,
        formatDateWithPattern(claimsCloseDate, config.DEFAULT_DATE_FORMAT)
      );
    }

    const fundraisingDeadlineDate = get(
      eventAmbassadorProgram,
      paths.FUNDRAISING_DEADLINE_DATE
    );
    if (fundraisingDeadlineDate && dayjs(fundraisingDeadlineDate).isValid()) {
      eventAmbassadorProgram = update.set(
        eventAmbassadorProgram,
        paths.FUNDRAISING_DEADLINE_DATE,
        formatDateWithPattern(fundraisingDeadlineDate, config.DEFAULT_DATE_FORMAT)
      );
    }

    //terms and conditions && waivers
    const termsAndConditionsEnabled = get(
      eventAmbassadorProgram,
      paths.TERMS_AND_CONDITIONS_ENABLED
    );
    const waiversEnabled = get(eventAmbassadorProgram, paths.WAIVERS_ENABLED);

    if (!termsAndConditionsEnabled) {
      templateOptions.hide(paths.TERMS_AND_CONDITIONS_TITLE);
      templateOptions.hide(paths.TERMS_AND_CONDITIONS_LINK);
    }

    if (!waiversEnabled) {
      templateOptions.hide(paths.WAIVERS);
    }

    templateOptions.setModel(eventAmbassadorProgram);

    templateOptions.isEdit();

    this.props.formBuilderActions.setFormBuilderModel(
      applicationsPartOneFormBuilder
    );
    this.props.formBuilderActions.setFormBuilderModel(
      applicationsPartTwoFormBuilder
    );
    this.props.templateBuilderActions.setTemplateModel(
      templateOptions.getWithRule()
    );
  };

  clearMessages = () => {
    this.props.programActions.clearRecordMessages('recordEdit');
  };

  goToVipProgramsView = () => {
    const returnUrl = NavigationStateManager.getReturnUrl();
    this.props.history.push(returnUrl || config.DEFAULT_PROGRAMS_URL);
  };

  render() {
    if (!this.isAllRecordsReady()) {
      return <Spinner />;
    }

    const eventAmbassadorProgram = get(
      this.props.eventAmbassadorProgramRecord,
      'data.data'
    );

    if (!this.props.isTemplateInited) {
      this.initTemplate();
    }

    const isSaving = Record.isRecordLoading(this.props.recordEdit);

    return (
      <BasePage>
        <RecordResultMessage
          record={this.props.recordEdit}
          onDismiss={this.clearMessages}
          redirectOnSuccess={this.goToVipProgramsView}
        />

        <h1>
          <Translate value="programs.template.edit-header" />{' '}
          {eventAmbassadorProgram ? eventAmbassadorProgram.name : ''}
        </h1>
        <VipProgramTemplate
          onSave={this.onSave}
          onCancel={this.onCancel}
          isLoading={isSaving}
        />
      </BasePage>
    );
  }
}

const mapState = ({ program, templateBuilderEx }) => {
  return {
    eventAmbassadorProgramRecord: program.eventAmbassadorProgramRecord,
    recordEdit: program.recordEdit,
    isTemplateInited: templateBuilderEx.inited
  };
};

const mapDispatch = (dispatch) => {
  return {
    programActions: bindActionCreators(programActions, dispatch),
    templateBuilderActions: bindActionCreators(
      templateBuilderActions,
      dispatch
    ),
    formBuilderActions: bindActionCreators(formBuilderActions, dispatch)
  };
};

/** Wrap component with page title first, then connect to Redux store */
const EditVipProgramWithPageTitle = withPageTitle((props) => {
  const programName = get(props, 'eventAmbassadorProgramRecord.data.data.name');
  const step = get(props, 'match.params.step', '');
  const tab = step ? step.charAt(0).toUpperCase() + step.slice(1) : '';
  
  return I18n.t('page-titles.vip-programs.edit-program', {
    programName,
    tab
  });
})(EditVipProgram);

const EditVipProgramContainer = clear(
  connect(mapState, mapDispatch)(EditVipProgramWithPageTitle)
);
export default withRouterV6(EditVipProgramContainer);
